export default "__VITE_ASSET__T2UKqOIt__"